import React from 'react'
import BaseIcon from './BaseIcon'
import img from 'assets/img/ic-unit-plan.png'

const PlanIcon = (props: any) => {
  return <BaseIcon img={img} onClick={props.onClick} size={props.size} />
}

export default PlanIcon
